module.exports = __webpack_public_path__ + "img/1.a2dd43b2.png";